import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
      } catch {}
      if (attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center">
      {status === "polling" && (
        <>
          <div className="font-display text-3xl text-[#2D2A26]">Confirming your enrollment...</div>
          <p className="text-[#5C5852] mt-4">This usually takes a few seconds.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 size={64} className="text-[#5F6F52] mx-auto" />
          <h1 className="font-display text-5xl text-[#2D2A26] mt-6 tracking-tight">Welcome in.</h1>
          <p className="text-[#5C5852] mt-4 text-lg leading-relaxed">
            Your enrollment is complete. The full course is unlocked. Begin where you are.
          </p>
          <button onClick={() => nav("/dashboard")} data-testid="payment-success-cta" className="btn-primary rounded-full px-8 py-4 mt-10 font-medium">
            Go to your dashboard
          </button>
        </>
      )}
      {status === "expired" && <div className="font-display text-3xl text-[#2D2A26]">Your checkout session expired.</div>}
      {status === "timeout" && <div className="font-display text-3xl text-[#2D2A26]">Still confirming... check your dashboard in a moment.</div>}
      {status === "error" && <div className="font-display text-3xl text-[#2D2A26]">Something went wrong.</div>}
    </div>
  );
}
